import React, { Component } from 'react';
import store from '../store';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import LockIcon from '@material-ui/icons/Lock';
import BackIcon from '@material-ui/icons/ChevronLeft';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import createHistory from 'history/createBrowserHistory';
import TopBar from '../components/TopBar2';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import firebase from "firebase/app";
import "firebase/firestore";
import * as STATIC from '../config/static';
import Modal from 'react-responsive-modal';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
let _this;
const DWIDTH = 1024;
function getParameterByName(name) {
    if (name !== "" && name !== null && name !== undefined) {
        name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(window.location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    } else {
        var arr = window.location.href.split("/");
        return arr[arr.length - 1];
    }
}

class Login extends Component {
  constructor() {
    super();
    let comp_id = getParameterByName("id");
    this.state = {
      username: '',
      password: '',
      email: '',
      remember: false,
      forgotPass: false,
      ACCOUNT: null,
      showForgot: false,
      showSent: false,
      loading:true,
      comp_id
    }
    _this = this;
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    if(!this.state.comp_id||this.state.comp_id.length==0)
    {
      this.setState({loading:false});
    }
    else {
      this.loadComp();
    }
    // this.setState({
    //   innerWidth: window.innerWidth,
    //   innerHeight: window.innerHeight
    // });
    //window.addEventListener("resize", this.updateDimensions);
    //this.loadBible();
  }
  async loadComp()
  {
    let comp = null;
    let data = await firebase.firestore().collection('comps').where("comp_id","==",_this.state.comp_id).get();
    if(data.size>0)
    {
      data.forEach(d=>{
        comp = d.data();
        comp.id = d.id;
      })
    }
    //console.log("AAA")
    _this.setState({comp,loading:false});
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    _this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }



  handleChange = name => event => {
    event.preventDefault();
    this.setState({
      [name]: event.target.value
    });
  }
  handleChangeCheckbox = name => event => {

    this.setState({
      [name]: event.target.checked
    });
  }
  handleKeypress = event => {
    //console.log(event.key);
    if (event.key === "Enter") {
      _this.LoginUser(_this.state.username,_this.state.password,event)
    }
  }

  handleForgot = () => event => {
    event.preventDefault();
    this.setState({
      forgotPass: true
    });
  }

  ForgotPasswordFirebase = () => event => {
    event.preventDefault();
    store.dispatch({ type: 'ERROR_LOGIN', MESSAGE: '' });
    firebase.auth().sendPasswordResetEmail(this.state.email).then(function() {
      alert("Email Sent");
      window.location.reload();
    }).catch(function(error) {
      store.dispatch({ type: 'ERROR_LOGIN', MESSAGE: error.message });
    });
  }

  handleResetPass = (newPassword) => event => {
    event.preventDefault();
    const actionCode = store.getState().actionCode;
    firebase.auth().verifyPasswordResetCode(actionCode).then(function(email) {
      firebase.auth().confirmPasswordReset(actionCode, newPassword).then(function(resp) {
        alert("Was reset the password");
        store.dispatch({ type: 'RESET_PASS', status: false, actionCode: '' });
      }).catch(function(error) {
        alert(error.message);
        store.dispatch({ type: 'RESET_PASS', status: false, actionCode: '' });
      });
    }).catch(function(error) {
      alert(error.message);
      store.dispatch({ type: 'RESET_PASS', status: false, actionCode: '' });
    });
    this.setState({
      reset1: '',
      reset2: ''
    });
  }

  BackResetPassword = () => event => {
    event.preventDefault();
    this.setState({
      forgotPass: false
    });
  }


  async LoginUser (username, password, event) {
    if(event&&event.preventDefault)
    event.preventDefault();
    // if (username == 'demo' && password == 'demo') {
    //   let ACCOUNT = { name: 'Jacky', class: 'Super' };
    //   localStorage.setItem('ACCOUNT', JSON.stringify(ACCOUNT));
    //   store.dispatch({ type: 'ACCOUNT', ACCOUNT });
    // }
    if(!username||username.trim().length==0 || !password || password.trim().length==0)
    {
      STATIC.NotificationManager.error(_this.props.t('login.enter_info'));
      return;
    }

    await _this.setState({loading:true});
    let data = await firebase.firestore().collection("competitors").where("username","==",username.trim().toUpperCase()).where("password","==",password.trim()).get();
    console.log(data.size);
    if(data.size>0)
    {
      let ACCOUNTCOMP = null;
      data.forEach(d=>{
        ACCOUNTCOMP = d.data();
      });
      let compdata = await firebase.firestore().collection('comps').where('comp_id',"==",ACCOUNTCOMP.comp_id).get();
        let comp = null;
  
        if(compdata.size>0)
        {
  
          compdata.forEach(d=>{
            comp = d.data();
            comp.id = d.id;
          })
        }
        console.log(comp)
        if(!comp||moment(comp.startDate,"YYYY-MM-DD").isAfter(moment())||moment(comp.endDate,"YYYY-MM-DD").isBefore(moment()))
        {
          await _this.setState({loading:false});
          return STATIC.NotificationManager.error(_this.props.t('login.not_correct'));
        }
      let rel = await firebase.firestore().collection("comp_token").where("acc_id","==",ACCOUNTCOMP.id).get();
      if(rel.size>0)
      {
        rel.forEach(d=>d.ref.delete());
      }
      let ref = await firebase.firestore().collection("comp_token").doc();
      let ACCOUNTCOMP_TOKEN = {id:ref.id,acc_id:ACCOUNTCOMP.id}
      await ref.set({id:ref.id,acc_id:ACCOUNTCOMP.id});
      //await firebase.firestore().collection("comp_token").set();
      localStorage.setItem('ACCOUNTCOMP', JSON.stringify(ACCOUNTCOMP));
      localStorage.setItem('ACCOUNTCOMP_TOKEN', JSON.stringify(ACCOUNTCOMP_TOKEN));

      store.dispatch({ type: 'ACCOUNTCOMP', ACCOUNTCOMP });
      store.dispatch({ type: 'ACCOUNTCOMP_TOKEN', ACCOUNTCOMP_TOKEN });

    }
    else {
      STATIC.NotificationManager.error(_this.props.t('login.not_correct'));

    }
    await _this.setState({loading:false});

  }
  async sendForgot  (username, email){

    if(!email||email.trim().length==0 || !username || username.trim().length==0)
    {
      STATIC.NotificationManager.error('Please enter your login info!');
      return;
    }
    await _this.setState({loading:true});
    let res = await STATIC.postFormData(STATIC.API_USER_SENDFORGOT,{username,email});
    console.log(res);
    if(res && res.status==1)
    {
      _this.setState({ showSent:true});
    }
    else {
      _this.setState({ MESSAGE: _this.props.t('login.not_found')});
    }
    await _this.setState({loading:false});

  }

  render() {
    const { classes } = this.props;
    const { username, password, email, remember, wWidth, wHeight,loading,comp } = this.state;
    const { t } = this.props;
    let width = 1024;
    let height = 640;

    // if (wWidth < width) {
    //   width = wWidth;
    // }

      height = wHeight;

    let sRate = 1024 / 1024;
    width = wHeight * sRate;
    if(width>wWidth)
    {
        width = wWidth;
        height = width/sRate;
    }
    let fBig = width * 0.07;
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;

    if (store.getState().ACCOUNTCOMP) {
      return <Redirect to='/competition' />
    }
    if (this.state.showForgot) {
      return (
        <div className={classes.root}>
          <div className={classes.middle}>
            
            {store.getState().ACCOUNT && createHistory().location.pathname !== '/' ? <Redirect to='/' /> : ''}
            <div className={classes.square} style={{ padding: 5 }} elevation={4}>

              <div style={{ padding: (STATIC.calSize(60, DWIDTH, width) + 'px ' + STATIC.calSize(20, DWIDTH, width) + 'px'), flexGrow: 1, position: 'relative' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.4)', zIndex: -1 }} />
                <div style={{ textAlign: 'center', marginBottom: STATIC.calSize(60, DWIDTH, width) }}>

                  <div style={{ textAlign: 'center', margin: 0, color: '#053f22', fontSize: fTitle, fontFamily: 'UTMP' }}>
                    Password Reset<br />___ Information ___
                    </div>


                </div>
                {!this.state.showSent ? (<div>
                  <div style={{display:'flex',flexDirection:"column"}}>
                    <div>
                      <div style={{ display: 'flex', height: STATIC.calSize(65, DWIDTH, width), justifyContent: 'center', alignItems: 'center', backgroundColor: 'white', marginBottom: STATIC.calSize(10, DWIDTH, width) }}>
                        <div style={{ width: STATIC.calSize(65, DWIDTH, width), height: STATIC.calSize(65, DWIDTH, width), background: '#8dc63f', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <img
                            src="assets/web/icon_mail.png"
                            style={{ width: STATIC.calSize(25, DWIDTH, width), height: 'auto', margin: 'auto', display: 'block' }} />
                        </div>
                        <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                          <input
                            value={email}
                            type="text"
                            placeholder="Email"
                            onChange={this.handleChange('email')}
                            style={{ border: 'none', height: STATIC.calSize(65, DWIDTH, width), width: '100%', padding: '0px ' + STATIC.calSize(20, DWIDTH, width) + 'px', color: '#053f22', fontSize: fNormal }} />
                        </div>
                      </div>

                    </div>
                    <div>
                      <div style={{ display: 'flex', height: STATIC.calSize(65, DWIDTH, width), justifyContent: 'center', alignItems: 'center', backgroundColor: 'white', marginBottom: STATIC.calSize(10, DWIDTH, width) }}>
                        <div style={{ width: STATIC.calSize(65, DWIDTH, width), height: STATIC.calSize(65, DWIDTH, width), background: '#8dc63f', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <img
                            src="assets/web/icon_acc.png"
                            style={{ width: STATIC.calSize(20, DWIDTH, width), height: 'auto', margin: 'auto', display: 'block' }} />
                        </div>
                        <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                          <input
                            value={username}
                            type="text"
                            placeholder={t('login.username')}
                            onChange={this.handleChange('username')}

                            style={{ border: 'none', height: STATIC.calSize(65, DWIDTH, width), width: '100%', padding: '0px ' + STATIC.calSize(20, DWIDTH, width) + 'px', color: '#053f22', fontSize: fNormal }} />
                        </div>
                      </div>

                    </div>

                  </div>
                  {this.state.MESSAGE ? (<p
                    style={{ color: 'red', marginTop: STATIC.calSize(10, DWIDTH, width), fontSize: fNormal, textAlign: 'center' }}>
                    {this.state.MESSAGE}
                  </p>)
                    : ''}

                  <div style={{display:'flex',flexDirection:"row",justifyContent:'center',alignItems:'center', marginTop: STATIC.calSize(25, DWIDTH, width) }}>


                    <div>

                      <Button style={{ color: "white", padding: (STATIC.calSize(6, DWIDTH, width) + 'px ' + STATIC.calSize(16, DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#8dc63f', fontWeight: 'bold', fontSize: fNormal, float: 'right', textTransform: "capitalize", fontWeight: 'normal' }} color="primary" size="large" variant="contained" onClick={()=>this.sendForgot(username, email)}>
                        {t('login.send')}
                                              </Button>
                    </div>
                  </div>
                </div>
                ) : (<div style={{display:'flex',flexDirection:"row",justifyContent:'center',alignItems:'center', backgroundColor: 'rgba(255, 255, 255, 0.4)' }} >
                  <div>
                    <div style={{ textAlign: 'center', margin: STATIC.calSize(100, DWIDTH, width) + "px 0", color: 'rgb(5, 63, 34)', fontSize: fTitle }} dangerouslySetInnerHTML={{__html: t('login.send_message')}} >

</div>


                  </div></div>)}
                <div onClick={() => this.setState({ MESSAGE: '', showForgot: false, showSent: false })} style={{ width: STATIC.calSize(40, DWIDTH, width), height: STATIC.calSize(40, DWIDTH, width), position: 'absolute', top: STATIC.calSize(20, DWIDTH, width), left: STATIC.calSize(20, DWIDTH, width), borderRadius: STATIC.calSize(20, DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} >
                  <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                </div>


              </div>
              <Grid container >
                <Grid item xs style={{ margin: STATIC.calSize(20, DWIDTH, width), position: 'relative' }}>
                  <div style={{ textAlign: 'center', margin: 0, color: 'white', fontSize: fSmall }}>
                    Copyright © Superbrain Group 2019
                </div>
                </Grid>
              </Grid>

            </div>
          </div>
          <Modal styles={{overlay:{padding:0}, modal: { minWidth: width * 0.8, background: 'none', boxShadow: 'none', color: "white" } }} showCloseIcon={false} focusTrapped={false} open={loading} onClose={() => this.setState({ loading: false })} center>
            <div style={{ width: width * 0.8, position: 'relative', borderRadius: STATIC.calSize(10, DWIDTH, width), padding: STATIC.calSize(10, DWIDTH, width) }}>
              <div style={{textAlign:'center'}}>
              <CircularProgress style={{color:'white'}}/>
              </div>
            </div>
          </Modal>

        </div>
      );
    }
    return (
      <div className={classes.root} style={{backgroundImage:comp&&comp.bg_main&&comp.bg_main.length>0?("url('"+comp.bg_main+"')"):"url('assets/comp/bg_comp.png')"}}>
        <div className={classes.middle}>
        <TopBar width={width} />
       

          {store.getState().ACCOUNTCOMP && createHistory().location.pathname !== '/' ? <Redirect to='/competition' /> : ''}
          <div className={classes.square} style={{ padding: 5 }} elevation={4}>
            <Grid container direction="row" alignItems="center" justify="center">
              <Grid item xs={12}  alignItems="center" justify="center" style={{display:"flex", margin: STATIC.calSize(20, DWIDTH, width), position: 'relative' }}>
                <div  style={{ textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center',backgroundImage:"url('assets/comp/square_name.png')",backgroundSize:"100% 100%", width: STATIC.calSize(640 , DWIDTH, width),height:STATIC.calSize(640 , DWIDTH, width)*377/1427, marginBottom: STATIC.calSize(60, DWIDTH, width) }}>
                    <div className="comp_text_gradient"  style={{fontSize:fBig,whiteSpace: "pre",textAlign:'center',lineHeight:STATIC.calSize(640 , DWIDTH, width)*377/1427/3+"px" }}>{comp?comp.name:"SUPERBRAIN\nSPEED MATH"}</div>
                </div>

              </Grid>
            </Grid>
            <div style={{ padding: (STATIC.calSize(60, DWIDTH, width) + 'px ' + STATIC.calSize(20, DWIDTH, width) + 'px'), flexGrow: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.0)', zIndex: -1 }} />

               <div style={{display:'flex',flexDirection:"column"}}>
                <form autocomplete="off">
                  <div style={{ display: 'flex', height: STATIC.calSize(205, DWIDTH, width), justifyContent: 'center', alignItems: 'center', marginBottom: STATIC.calSize(30, DWIDTH, width) }}>

                    <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>

                      <input
                        type="text" autocomplete="off"
                        className="comp_input"
                        value={username}

                        placeholder={t('login.username')}
                        onChange={this.handleChange('username')}
                        onKeyPress={this.handleKeypress}
                        style={{ border: 'none',textAlign:'center', height: STATIC.calSize(175, DWIDTH, width), width: '100%', padding: '0px ' + STATIC.calSize(20, DWIDTH, width) + 'px', fontSize:fTitle }} />

                  </div>
                  </div>

                </form>
                <form autocomplete="off">
                  <div style={{ display: 'flex', height: STATIC.calSize(205, DWIDTH, width), justifyContent: 'center', alignItems: 'center', marginBottom: STATIC.calSize(30, DWIDTH, width) }}>

                    <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                      <input
                        value={password}
                        autocomplete="off"
                        type="password"
                        className="comp_input"
                        placeholder={t('login.password')}
                        onChange={this.handleChange('password')}
                        onKeyPress={this.handleKeypress}
                        style={{ border: 'none',textAlign:'center', height: STATIC.calSize(175, DWIDTH, width), width: '100%', padding: '0px ' + STATIC.calSize(20, DWIDTH, width) + 'px', fontSize: fTitle }} />
                    </div>
                  </div>

                </form>

              </div>
              <Grid container direction="row" alignItems="center" justify="center">
                <Grid item xs={12}  alignItems="center" justify="center" style={{display:"flex", margin: STATIC.calSize(20, DWIDTH, width), position: 'relative' }}>
                  <ButtonBase onClick={(e)=>this.LoginUser(username, password,e)}  style={{ textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center',backgroundImage:"url('assets/comp/button.png')",backgroundSize:"100% 100%", width: STATIC.calSize(500 , DWIDTH, width),height:STATIC.calSize(500 , DWIDTH, width)*155/493, marginBottom: STATIC.calSize(60, DWIDTH, width) }}>
                      <div className="comp_text_gradient"  style={{fontSize:fLarge,whiteSpace: "pre",textAlign:'center',lineHeight:STATIC.calSize(500 , DWIDTH, width)*155/493/3+"px" }}>{t('login.signin')}</div>
                  </ButtonBase>

                </Grid>
              </Grid>


            </div>


          </div>
        </div>
        <Modal styles={{overlay:{padding:0}, modal: { minWidth: width * 0.8, background: 'none', boxShadow: 'none', color: "white" } }} showCloseIcon={false} focusTrapped={false} open={loading} onClose={() => this.setState({ loading: false })} center>
          <div style={{ width: width * 0.8, position: 'relative', borderRadius: STATIC.calSize(10, DWIDTH, width), padding: STATIC.calSize(10, DWIDTH, width) }}>
            <div style={{textAlign:'center'}}>
            <CircularProgress style={{color:'white'}}/>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles2)(STATIC.translate('common')(Login));
